import { useState } from "react";
import useYMMTMaps from "./useYMMTMaps";
import isError from "../utils/is-error";

const useYMMTLabels = (initYMMTIds) => {
  const [ymmtIds, setYMMTIds] = useState(initYMMTIds);

  const [
    {
      years = new Map(),
      makes = new Map(),
      models = new Map(),
      trims = new Map(),
    },
    setYMMTIdsForMaps,
  ] = useYMMTMaps(initYMMTIds);

  const { yearId, makeId, modelId, trimId } = ymmtIds;

  const errors = [years, makes, models, trims].filter(isError);

  return [
    [
      isError(years) ? "" : years.get(yearId),
      isError(makes) ? "" : makes.get(makeId),
      isError(models) ? "" : models.get(modelId),
      isError(trims) ? "" : trims.get(trimId),
      errors,
    ],
    (newIds) => {
      setYMMTIdsForMaps(newIds);
      setYMMTIds(newIds);
    },
  ];
};

export default useYMMTLabels;
